<div class="container">
  <h2 class="text-center">{{ heading }}</h2>
  <div class="sns text-center" *ngIf="showSNS == true">
    <img src="/assets/sns-logo-small.png">
    <p>Effortless Document Destruction with <b>Tracking</b> and a <b>Certificate of Destruction</b>!</p>
    <a class="button" href="https://www.shipnshred.com" target="_blank">Learn More</a>
    <div class="or">OR</div>
  </div>
  <div class="row d-flex align-items-center my-3 justify-content-center" *ngIf="retailAction == false">
    <div [class]="exclusive() ? styleExclusiveForm() : 'col-md-10'">
      <form class="p-4" ngForm #infoForm="ngForm" novalidate #formNative
            action="https://xnforms.salesstarnetworks.com/form.php" [ngStyle]="{'min-height': showExclusive ? '600px' : '450px;', 'text-align': '-webkit-center'}">

        <p [innerHTML]="desc"></p>
        <div class="form-wrapper" [ngStyle]="{'visibility': show == true ? 'visible' : 'hidden', 'position': 'static'}">
          <div class="form-group pt-2">
            <p class="message" *ngIf="!name.valid && !name.pristine">
              Name is required
            </p>
            <label for="lead_contact">Name *</label>
            &nbsp;&nbsp;
            <input class="form-control"
                   type="text"
                   name="lead_contact"
                   placeholder="John Doe"
                   ngModel
                   #name="ngModel"
                   required />
          </div>
          <div class="form-group">
            <label for="lead_company">Company</label>
            &nbsp;&nbsp;
            <input class="form-control"
                   type="text"
                   name="lead_company"
                   placeholder="Company"
                   ngModel
                   #company="ngModel" />
          </div>
          <div class="form-group">
            <p class="message" *ngIf="!phone.valid && !phone.pristine">
              Phone is required
            </p>
            <label for="lead_phone">Phone *</label>
            &nbsp;&nbsp;
            <input class="form-control"
                   type="tel"
                   name="lead_phone"
                   placeholder="999-999-9999"
                   ngModel
                   #phone="ngModel"
                   required />
            <div *ngIf="phone.errors" [ngClass]="'error'" style="color: red">
              <div *ngIf="phone.errors.pattern">
                Phone number is not valid. Must be of format ###-###-####.
              </div>
            </div>
          </div>
          <div class="form-group">
            <p class="message" *ngIf="!email.valid && !email.pristine">
              Email is required
            </p>
            <label for="lead_email">Email * </label>
            &nbsp;&nbsp;
            <input class="form-control"
                   type="email"
                   name="lead_email"
                   placeholder="example@email.com"
                   ngModel
                   #email="ngModel"
                   required />
          </div>
          <div class="form-group">
            <p class="message" *ngIf="(!zip.valid && !zip.pristine) || showErrors">
              Zip/Postal Code is required and cannot contian special characters.
            </p>
            <label for="lead_zip">Zip/Postal Code*</label>
            <input class="form-control"
                   type="text"
                   name="lead_zip"
                   placeholder="12345"
                   ngModel
                   #zip="ngModel"
                   required
                   pattern="[a-zA-Z0-9\s]{0,10}" />
          </div>
          <div class="hidden-fields" [innerHTML]="hiddenFields" #hidden></div>
          <div class="form-group">
            <label for="lead_desc">Additional Details</label>
            &nbsp;&nbsp;
            <textarea class="form-control"
                      type="text"
                      name="lead_desc"
                      placeholder="Enter a small description of your project"
                      ngModel
                      #lead_desc="ngModel"></textarea>
          </div>
          <div class="form-group text-center">
            <button type="submit"
                    class="btn btn-block"
                    (click)="onSubmit(infoForm)"
                    [disabled]="!infoForm.valid">
              GET QUOTES
            </button>
            <div class="spinner-wrapper" *ngIf="nav.showSpinner === true">
              <mat-progress-spinner class="spinner"
                                    [color]="'warn'"
                                    [mode]="'indeterminate'"
                                    [value]="30">
              </mat-progress-spinner>
            </div>
          </div>
        </div>
        <ng-template #noMatch>
          <div class="form-wrapper" [ngStyle]="{'visibility': show == false ? 'visible' : 'hidden', 'position': checkStep() == 2 ? 'static' : 'absolute'}" style="padding: 50px;">
            <p>
              We were unable to directly match your needs to a service provider. However,
              our customer service representatives may still be able to find a provider for you.
              Please call our toll free number for assistance.
            </p>
          </div>
        </ng-template>
      </form>
    </div>
  </div>
  <div class="row my-2" *ngIf="retailAction == true">
    <div class="col-md-8 offset-md-2">
      <p class="text-center" [innerHTML]="desc"></p>
      <input
        class="form-control text-center"
        type="text"
        name="zip"
        placeholder="Enter Zip Here"
        #zipInput
      />
      <div class="listings" [innerHTML]="listings" style="width: 100%"></div>
    </div>
    <div class="col-md-7 col-11 mx-auto pt-3 more-info">
      <div class="mx-auto" [innerHTML]="moreInfo"></div>
    </div>
  </div>
</div>
